import React from 'react';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';
import StructureFilterPreview from './StructureFilterPreview';

import './StructureFilter.scss';

export function DrawInEditor(props) {
  const { onClick } = props;

  return (
    <ButtonWithIcon
      type="link"
      size="small"
      linkIconSize="m"
      sprite="DrawStructureNew"
      onClick={onClick}
      className="u-els-display-flex u-els-padding-1o2 structure-filter-drawing e2e-draw-structure">
      Draw
    </ButtonWithIcon>
  );
}

export default function StructureFilter(props) {
  const { onClick, drawing } = props;

  return (
    <section className="structure-filter u-els-padding-3o4">
      {drawing ? <StructureFilterPreview {...props} /> : <DrawInEditor onClick={onClick} />}
    </section>
  );
}

StructureFilter.propTypes = {
  drawing: PropTypes.shape({
    preview: PropTypes.string.isRequired,
  }),
  onClick: PropTypes.func.isRequired,
  drawOnClick: PropTypes.func.isRequired,
  clearDrawn: PropTypes.func.isRequired,
  optionsButtonOnClick: PropTypes.func.isRequired,
};
